import React, { useState } from "react";

import {
  useNavigate
} from "react-router-dom";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//components
import IconButton from "./IconButton";

//icons
import {
  Eye,
  Trash2
} from "react-feather";

//api
import api from "../services/api";

//auth
import {
  useAuth
} from "../providers/auth";

//Sweet alert
import Swal from "sweetalert2";

export default function PresetItem(props) {
  const { user } = useAuth();
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const token = { headers: { "Authorization": "Bearer " + user.token } };

  async function onDelete(command) {
    setLoading(true);

    try {
      const response = await api.post("/presets/remove/" + command, token);

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      } else {
        props.onDelete(command);

        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);
      }
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  const onEditPreset = (command) => navigate("/utils/presets/"+command);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  return (
    <li className="fk-table__item fk-table__item--body">
      <div className="fk-table__item-name fk-table__item-name--first fk-table__item--w-sm">
        <p className="u-text-limit-150">{props.preset.command}</p>
      </div>
      <div className="fk-table__item-name fk-table__item-name--second fk-table__item--w-md">
        <p className="u-text-limit u-no-margin">{props.preset.body}</p>
      </div>
      <div className="fk-table__item-name fk-table__item-name--lastone">
        <IconButton
          type="button"
          variant="warning"
          loading={false}
          disabled={props.deleteLoading}
          onClick={() => onEditPreset(props.preset.command)}>
          <Eye />
        </IconButton>
      </div>
      <div className="fk-table__item-name fk-table__item-name--lastone">
        <IconButton
          type="button"
          variant="danger"
          loading={loading}
          disabled={props.deleteLoading}
          onClick={() => onDelete(props.preset.command)}>
          <Trash2 />
        </IconButton>
      </div>
    </li>
  );
}